import React from 'react';
import { Alert, Form, Icon, Input, Button } from 'antd';
import { connect } from 'react-redux';
import get from 'lodash/get';

import {getUserToken} from "../../reducers/user/selectors";
import { setPasswordConfirmUserRequest, setPasswordConfirmRequest } from '../../api/requests';
import { passwordValidationRegex } from "../../utils/passwordValidationRegex";

import classes from './SetAccountPasswordForm.css';
import { withNamespaces } from 'react-i18next';
import { getTheme } from '../../reducers/theme/selectors';
import logoDefault from "../../assets/img/diamind_logo.png";

const routes = require('../../routes.json');

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class SetAccountPasswordForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      responseMessage: null,
      errorMessage: null,
      isSubmitted: false,
      checkConfirmRequestError: 'Checking...',
      username: '',
    };
  }

  async componentDidMount() {
    if (this.props.token) {
      try {
        const { data } = await setPasswordConfirmUserRequest({ token: this.props.token });
        this.setState({ checkConfirmRequestError: null, username: data.username });
      } catch (e) {
        this.setState({ checkConfirmRequestError: get(e, 'response.data.message') });
      }
    }
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true });

      if (!err) {
        this.setState({ isLoading: true, errorMessage: null, responseMessage: null });

        try {
          await setPasswordConfirmRequest({ password: get(values, 'password'), confirm_password: get(values, 'passwordConfirm'), token: this.props.token });
          this.setState({ responseMessage: this.props.i18n.t('Success') });
          setTimeout(() => {
            this.props.history.push(routes.admin.login);
          }, 1200);
        } catch (err) {
          this.setState({ errorMessage: get(err, 'response.data.msg'), isLoading: false});
        }
      }
    });
  };


  render() {
    const { getFieldDecorator, getFieldsError, getFieldError, isFieldTouched } = this.props.form;
    const { isLoading, errorMessage, responseMessage, isSubmitted, checkConfirmRequestError, username } = this.state;

    const passwordError = (isFieldTouched('password') || isSubmitted) && getFieldError('password');
    const passwordConfirmError = (isFieldTouched('passwordConfirm') || isSubmitted) && getFieldError('passwordConfirm');

    return (
      <div className={classes.loginForm}>
        <Form onSubmit={this.handleSubmit}>
          <h2 className={classes.headline}>
            <img alt="diamond-trial-logo" src={this.props.theme.logo_dark} style={{ objectFit: 'contain', width: '160px', height: 'auto' }} />
            <br/>
            {this.props.i18n.t('NamespaceSetAccountPasswordForm:Set Account Password')}
          </h2>
          {username && <p>For: <b>{username}</b></p>}

          {!checkConfirmRequestError && (<div>
            <Form.Item validateStatus={passwordError ? 'error' : ''} help={passwordError || ''}>
              {getFieldDecorator('password', {
                rules: [
                  { required: true, message: this.props.i18n.t('Required') },
                  {
                    pattern: passwordValidationRegex,
                    message: this.props.i18n.t('NamespaceSetAccountPasswordForm:The password must contain at least one UPPERCASE letter, one lowercase letter, one number. Password length between 8-32 characters.')
                  }
                ]
              })(
                <Input type='password' prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder={this.props.i18n.t('Password')} />,
              )}
            </Form.Item>
            <Form.Item validateStatus={passwordConfirmError ? 'error' : ''} help={passwordConfirmError || ''}>
              {getFieldDecorator('passwordConfirm', {
                rules: [{ required: true, message: this.props.i18n.t('Required') }]
              })(
                <Input type='password' prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder={this.props.i18n.t('NamespaceSetAccountPasswordForm:Repeat password')} />,
              )}
            </Form.Item>
          </div>)}

          {errorMessage && <Alert message={errorMessage} type="error" className={classes.alertsMb} />}
          {responseMessage && <Alert message={responseMessage} type="success" className={classes.alertsMb} />}
          {checkConfirmRequestError && <Alert message={checkConfirmRequestError} type="error" className={classes.alertsMb} />}

          {!responseMessage && !checkConfirmRequestError && (<Form.Item>
            <Button type="primary" size="large" htmlType="submit" disabled={hasErrors(getFieldsError())} className={classes.submitButton}>
              {this.props.i18n.t('NamespaceSetAccountPasswordForm:Set password')}
              {isLoading && <Icon type="loading" />}
            </Button>
          </Form.Item>)}
        </Form>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  userToken: getUserToken(state),
  theme: getTheme(state)
});

export default Form.create({ name: 'login' })(connect(mapStateToProps)(withNamespaces()(SetAccountPasswordForm)));



// WEBPACK FOOTER //
// ./src/components/SetAccountPasswordForm/SetAccountPasswordForm.js